<template>
  <ais-refinement-list
    :attribute="attribute"
    operator="or"
    :class-names="{
      'ais-RefinementList-checkbox': 'd-none'
      }">
      <template v-slot="{ items, refine }">
        <ul class="p-0">
          <div v-if="label && items.length > 0" class="mb-1 fw-bold">{{ label }}</div>
          <li class="list-inline py-1" v-for="item in items" :key="item.id">
            <input type="checkbox" class="btn-check" id="btn-check" autocomplete="off" :checked="item.isRefined">
            <label :id="'btn-label-' + kebab_case(item.label)" class="btn btn-outline-primary rounded-pill fw-normal text-nowrap py-1" for="btn-check" @click.prevent="refine(item.value)">
              {{ item.label }} ({{ item.count }})
            </label>
          </li>
        </ul>
      </template>
</ais-refinement-list>
</template>

<script>
import { AisRefinementList } from 'vue-instantsearch/vue3/es';
import _ from 'lodash';

export default {
  name: 'SearchToggleGroup',
  props: {
    attribute: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
  },
  components: {
    AisRefinementList,
  },
  methods: {
    kebab_case(value) {
      return _.kebabCase(value);
    },
  },
};
</script>
